module.exports = __webpack_public_path__ + "static/media/closeLight.2a644a92.svg";